import React from 'react';
import ReactDOM from 'react-dom';
import Clarity from '@microsoft/clarity';
// import { observer } from '@devsigner-com/observer-sdk';

import App from './App';

// Clarity.init('q0ju6f1o6i');
Clarity.init('tyexk08vbc');

// observer.init({
//   endpoint: 'https://api.monitor.koro.com.br/observer',
//   batchInterval: 5000,
//   maxQueueSize: 200,
//   captureRequestBody: true,
//   captureResponseBody: true,
//   captureHeaders: true,
//   includeUrls: [/\.koro\.com\.br/],
//   name: `Koro Atleta (${process.env.REACT_APP_BRANCH})`,
// });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
